// Display copy of the server's price list (functions/payments.js). The server
// re-checks every amount, so a mismatch here fails the purchase rather than
// under-charging.
export const PRODUCTS = {
  coins_100: { priceNgn: 1000, priceUsdCents: 199, coins: 100 },
  coins_280: { priceNgn: 2500, priceUsdCents: 299, coins: 280 },
  coins_500: { priceNgn: 4000, priceUsdCents: 399, coins: 500 },
  coins_1000: { priceNgn: 7000, priceUsdCents: 599, coins: 1000 },
  pro_monthly: { priceNgn: 2500, priceUsdCents: 399 },
  pro_onetime: { priceNgn: 3500, priceUsdCents: 499 },
};

// +1/+3/+5 bundles; in naira and coins a custom count costs the cheapest mix
// of them. In dollars every extra seat is $1 more ($1.99 … $10.99), which must
// match functions/payments.js.
export const SEAT_BUNDLES = [
  { seats: 1, priceNgn: 1000, priceUsdCents: 199, coinCost: 100 },
  { seats: 3, priceNgn: 2500, priceUsdCents: 399, coinCost: 280 },
  { seats: 5, priceNgn: 4000, priceUsdCents: 599, coinCost: 450 },
];
const cheapestMix = (n, key) => {
  const best = [0];
  for (let i = 1; i <= n; i++) {
    best[i] = Math.min(...SEAT_BUNDLES.filter((b) => b.seats <= i).map((b) => best[i - b.seats] + b[key]));
  }
  return best[n];
};
for (let n = 1; n <= 10; n++) {
  PRODUCTS[`seats_${n}`] = {
    seats: n,
    priceNgn: cheapestMix(n, "priceNgn"),
    priceUsdCents: 99 + 100 * n,
    coinCost: cheapestMix(n, "coinCost"),
  };
}

export const seatProductId = (seats) => `seats_${seats}`;

export const coinProductId = (coins) => `coins_${coins}`;

export const formatNaira = (amount) => `₦${amount.toLocaleString()}`;

export const formatUsd = (cents) => `$${(cents / 100).toFixed(2)}`;

// Price of a product in the buyer's payment currency ("NGN" | "USD").
export const formatProductPrice = (productId, currency) => {
  const product = PRODUCTS[productId];
  return currency === "USD" ? formatUsd(product.priceUsdCents) : formatNaira(product.priceNgn);
};

// Paddle price IDs from scripts/seed-paddle-catalog.mjs, keyed by product. Paddle
// sells the seat bundles and the Pro pass under their own SKUs; larger custom
// seat counts are bought as several bundles (see paddleService.itemsFor).
// Sandbox and live catalogs have different IDs: fill PADDLE_PRICES.live after
// running the seed script with --live.
export const PADDLE_PRICES = {
  sandbox: {
    coins_100: "pri_01m3950dn5bnehar78k9sj9pev",
    coins_280: "pri_01m3950em97tpsp725cqqjmwpr",
    coins_500: "pri_01m3950ffzbb6c4hdz7mv0gk62",
    coins_1000: "pri_01m3950gajhywap95jbe7px4bc",
    seats_1: "pri_01m3950h415v7tc6hze3skrwh1",
    seats_3: "pri_01m3950j02srv439rw5p37s8cs",
    seats_5: "pri_01m3950jwfxhk1dqwhmgv1fjaw",
    pro_monthly: "pri_01m3950kpx34qtb24vpss68bw6",
    pro_onetime: "pri_01m3950mjf4985rezdt6hk5hxd",
  },
  live: {},
};
